import React from 'react'
import { NavLink } from "react-router-dom"
import CartBtn from './buttons/Cartbtn'
import Login from './buttons/Login'
import Signup from './buttons/Signup'

const Header = () => {
    return (
        <div>
            <nav className="navbar navbar-expand-lg navbar-light bg-light">
                <div className='container-fluid py-2'>

                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav mr-auto">
                            <li className="nav-item ">
                                <NavLink className="nav-link" to="/">Home <span className="sr-only">(current)</span></NavLink>
                            </li>
                            <li className="nav-item ">
                                <NavLink className="nav-link" to="/product">Product <span className="sr-only">(current)</span></NavLink>
                            </li>
                            <li className="nav-item ">
                                <NavLink className="nav-link" to="/contact">Contact <span className="sr-only">(current)</span></NavLink>
                            </li>
                            <li className="nav-item ">
                                <NavLink className="nav-link" to="/about">About <span className="sr-only">(current)</span></NavLink>
                            </li>
                        </ul>
                    <NavLink className="navbar-brand mx-auto font-weight-bold" to="/">APPLE MART</NavLink> <br />
                    <Login/>
                    <Signup/>
                    
                    <CartBtn/>
                    </div>
                </div>
            </nav>
        </div>
    )
}

export default Header